import { USER_TYPE } from './constant';

const isBlank = (value) => !value || !String(value).trim();

export const validateBasicDetailsStep = async ({
  formState1,
  isOkButtonClicked,
  hprNullCheck,
  ishprEntered,
  hprNumberCheck,
  isNotVerified,
  userDesignationConstant,
  checkEmailAlreadyExists,
  checkMobileNumberExists,
  onDispatchUpdate,
  onOpenAlert,
}) => {
  const formStateTemp1 = { ...formState1 };
  let isFormError = false;

  const validationPromises = Object.keys(formStateTemp1).map(async (item) => {
    if (item === 'fName') {
      if (isBlank(formStateTemp1.fName.value)) {
        isFormError = true;
        formStateTemp1.fName.isError = true;
        formStateTemp1.fName.message = 'First name cannot be kept blank. Enter a valid first name.';
      } else if (!/^[A-Za-z]+(?:[.\s]+[A-Za-z]+)*\.?$/.test(formStateTemp1.fName.value)) {
        isFormError = true;
        formStateTemp1.fName.isError = true;
        formStateTemp1.fName.message = 'Entered first name is invalid. Only alphabets,spaces and dot(.) are allowed.';
      } else if (formStateTemp1.fName.value.length > 100) {
        isFormError = true;
        formStateTemp1.fName.isError = true;
        formStateTemp1.fName.message = 'Entered first name length is invalid. Max 100 characters are allowed.';
      } else {
        formStateTemp1.fName.isError = false;
      }
    } else if (item === 'lName') {
      if (isBlank(formStateTemp1.lName.value)) {
        isFormError = true;
        formStateTemp1.lName.isError = true;
        formStateTemp1.lName.message = 'Last name cannot be kept blank. Enter a valid last name.';
      } else if (!/^[a-zA-Z\s]+$/.test(formStateTemp1.lName.value)) {
        isFormError = true;
        formStateTemp1.lName.isError = true;
        formStateTemp1.lName.message = 'Entered last name is invalid. Number & Special characters are not allowed.';
      } else if (formStateTemp1.lName.value.length > 100) {
        isFormError = true;
        formStateTemp1.lName.isError = true;
        formStateTemp1.lName.message = 'Entered last name length is invalid. Max 100 characters are allowed.';
      } else {
        formStateTemp1.lName.isError = false;
      }
    } else if (item === 'mob') {
      if (!formStateTemp1.mob.value.length) {
        isFormError = true;
        formStateTemp1.mob.isError = true;
        formStateTemp1.mob.message = 'Phone number cannot be left blank. Please enter a valid phone number.';
      } else if (formStateTemp1.mob.value.length !== 10) {
        isFormError = true;
        formStateTemp1.mob.isError = true;
        formStateTemp1.mob.message = 'Invalid Entry. Enter 10 digits valid Phone Number.';
      } else if (formStateTemp1.mob.value.startsWith('0') || formStateTemp1.mob.value.startsWith('+91')) {
        isFormError = true;
        formStateTemp1.mob.isError = true;
        formStateTemp1.mob.message = 'Invalid Entry. Enter 10 digits valid Phone Number.';
      } else {
        const mobileExists = await checkMobileNumberExists(formStateTemp1?.mob?.value);
        if (mobileExists) {
          isFormError = true;
          formStateTemp1.mob.isError = true;
          formStateTemp1.mob.message = 'Mobile number already registered with a different user.';
        } else {
          formStateTemp1.mob.isError = false;
        }
      }
    } else if (item === 'a_mob') {
      if (formStateTemp1.a_mob.value) {
        if (formStateTemp1.a_mob.value.length !== 10) {
          formStateTemp1.a_mob.isError = true;
          formStateTemp1.a_mob.message = 'Invalid Entry. Enter 10 digits valid Phone Number.';
        } else if (formStateTemp1.a_mob.value.startsWith('0') || formStateTemp1.a_mob.value.startsWith('+91')) {
          isFormError = true;
          formStateTemp1.a_mob.isError = true;
          formStateTemp1.a_mob.message = 'Invalid Entry. Enter 10 digits valid Phone Number.';
        } else {
          formStateTemp1.a_mob.isError = false;
        }
      }
    } else if (item === 'email') {
      if (formStateTemp1.email.value && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formStateTemp1.email.value)) {
        formStateTemp1.email.isError = true;
        isFormError = true;
        formStateTemp1.email.message = 'Enter correct Email format to continue.';
      } else if (String(formStateTemp1.email.value || '').trim()) {
        const emailExists = await checkEmailAlreadyExists(String(formStateTemp1.email.value).trim());
        if (emailExists) {
          formStateTemp1.email.isError = true;
          isFormError = true;
          formStateTemp1.email.message = 'Email already registered with a different user.';
        }
      } else {
        formStateTemp1.email.isError = false;
      }
    } else if (item === 'user_type') {
      if (!formStateTemp1.user_type.value) {
        isFormError = true;
        formStateTemp1.user_type.isError = true;
        formStateTemp1.user_type.message = 'User Type cannot be kept blank. Select an user type from Dropdown.';
      } else {
        formStateTemp1.user_type.isError = false;
      }
    } else if (item === 'designation') {
      if (!formStateTemp1.designation.value) {
        isFormError = true;
        formStateTemp1.designation.isError = true;
        formStateTemp1.designation.message = 'Designation cannot be kept blank. Select an user designation from Dropdown.';
      } else {
        formStateTemp1.designation.isError = false;
      }
    } else if (item === 'doj') {
      if (!formStateTemp1.doj.value) {
        isFormError = true;
        formStateTemp1.doj.isError = true;
        formStateTemp1.doj.message = 'DOJ cannot be kept blank. Select a valid Date of Registration on JANANI.';
      } else {
        formStateTemp1.doj.isError = false;
      }
    } else if (item === 'hpr_id' && formStateTemp1.hpr_id.value) {
      if (!/^[0-9]+$/.test(formStateTemp1.hpr_id.value)) {
        isFormError = true;
        formStateTemp1.hpr_id.isError = true;
        formStateTemp1.hpr_id.message = 'Entered hpr id is invalid. Alphabets & Special characters are not allowed.';
        onDispatchUpdate('hprNullCheck', false);
        onDispatchUpdate('hprNumberCheck', false);
        onDispatchUpdate('isOkButtonClicked', false);
        onDispatchUpdate('ishprEntered', false);
      } else {
        formStateTemp1.hpr_id.isError = false;
      }
    }

    if (
      !isFormError &&
      !formStateTemp1.hpr_id.value &&
      (formState1.user_type.value === USER_TYPE.FACILITY_LEVEL || formState1.user_type.value === USER_TYPE.FIELD_LEVEL) &&
      !isOkButtonClicked &&
      !hprNullCheck
    ) {
      if (
        formState1.designation.value !== userDesignationConstant.h_a_dh_sdh &&
        formState1.designation.value !== userDesignationConstant.h_a_other_central_government_hospitals &&
        formState1.designation.value !== userDesignationConstant.medical_director &&
        formState1.designation.value !== userDesignationConstant.medical_suprintendent
      ) {
        onOpenAlert();
        isFormError = true;
        onDispatchUpdate('hprNullCheck', true);
        onDispatchUpdate('hprNumberCheck', false);
        onDispatchUpdate('ishprEntered', false);
      }
    }

    if (!ishprEntered && formStateTemp1.hpr_id.value && /^[0-9]+$/.test(formStateTemp1.hpr_id.value) && !hprNumberCheck) {
      onOpenAlert();
      isFormError = true;
      onDispatchUpdate('hprNumberCheck', true);
      onDispatchUpdate('hprNullCheck', false);
      onDispatchUpdate('clearHpr', false);
      onDispatchUpdate('isOkButtonClicked', false);
    }

    if (
      (formState1.user_type.value === USER_TYPE.FACILITY_LEVEL || formState1.user_type.value === USER_TYPE.FIELD_LEVEL) &&
      formStateTemp1.hpr_id.value &&
      /^[0-9]+$/.test(formStateTemp1.hpr_id.value) &&
      isNotVerified
    ) {
      onOpenAlert();
      isFormError = true;
    }
  });

  await Promise.all(validationPromises);
  return { nextState: formStateTemp1, isFormError };
};

export const validateRoleHierarchyStep = ({ roleFormState, roleFormData }) => {
  const tempChange2 = {
    ...roleFormState,
  };
  const tempFormData2 = {
    ...roleFormData,
  };

  let isFormError = false;
  Object.keys(tempChange2).forEach((item) => {
    if (item === 'role_name' && tempFormData2[item]['#required'] === true) {
      if (!tempChange2.role_name.value || tempChange2.role_name.value.length <= 0) {
        tempChange2.role_name.isError = true;
        tempChange2.role_name.message = 'Role cannot be kept blank. Select user role(s)  from dropdown.';
        isFormError = true;
      } else {
        tempChange2.role_name.isError = false;
      }
    } else if (item === 'state' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false) {
      if (!tempChange2.state.value) {
        isFormError = true;
        tempChange2.state.isError = true;
        tempChange2.state.message = 'State cannot be kept blank. Select user state from dropdown.';
      } else {
        tempChange2.state.isError = false;
      }
    } else if (item === 'zone_div_circle' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false) {
      if (tempChange2.zone_div_circle.value?.length === 0 || tempChange2.zone_div_circle.value === undefined) {
        isFormError = true;
        tempChange2.zone_div_circle.isError = true;
        tempChange2.zone_div_circle.message = 'Zone/Division/Circle cannot be kept blank. Select user Zone/Division/Circle from dropdown.';
      } else {
        tempChange2.district.isError = false;
      }
    } else if (item === 'district' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false) {
      if (!tempChange2.district.value) {
        isFormError = true;
        tempChange2.district.isError = true;
        tempChange2.district.message = 'District cannot be kept blank. Select user District from dropdown.';
      } else {
        tempChange2.district.isError = false;
      }
    } else if (item === 'sub_district' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false) {
      if (!tempChange2.sub_district.value) {
        isFormError = true;
        tempChange2.sub_district.isError = true;
        tempChange2.sub_district.message = 'Sub District cannot be kept blank. Select user Sub District from dropdown.';
      } else {
        tempChange2.sub_district.isError = false;
      }
    } else if (item === 'health_block' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false) {
      if (!tempChange2.health_block.value) {
        isFormError = true;
        tempChange2.health_block.isError = true;
        tempChange2.health_block.message = 'Health Block cannot be kept blank. Select user Health Block from dropdown.';
      } else {
        tempChange2.health_block.isError = false;
      }
    } else if (item === 'sub_division' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false) {
      if (!tempChange2.sub_division.value) {
        isFormError = true;
        tempChange2.sub_division.isError = true;
        tempChange2.sub_division.message = 'Sub Division cannot be kept blank. Select user Sub Division from dropdown.';
      } else {
        tempChange2.sub_division.isError = false;
      }
    } else if (item === 'rural_urban' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false) {
      if (!tempChange2.rural_urban.value) {
        isFormError = true;
        tempChange2.rural_urban.isError = true;
        tempChange2.rural_urban.message = 'Select Rural or Urban from the dropdown.';
      } else {
        tempChange2.rural_urban.isError = false;
      }
    } else if (item === 'ulb' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false) {
      if (!tempChange2.ulb.value) {
        isFormError = true;
        tempChange2.ulb.isError = true;
        tempChange2.ulb.message = 'Select ULB from the dropdown.';
      } else {
        tempChange2.ulb.isError = false;
      }
    } else if (item === 'block' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false) {
      if (!tempChange2.block.value) {
        isFormError = true;
        tempChange2.block.isError = true;
        tempChange2.block.message = 'Select Block from the dropdown.';
      } else {
        tempChange2.block.isError = false;
      }
    } else if (item === 'ward' && tempChange2.rural_urban.value === 'Urban' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false) {
      if (!tempChange2.ward.value) {
        isFormError = true;
        tempChange2.ward.isError = true;
        tempChange2.ward.message = 'Select Ward from the dropdown.';
      } else {
        tempChange2.ward.isError = false;
      }
    } else if (item === 'village' && tempChange2.rural_urban.value === 'Rural' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false && tempFormData2[item]['#isVisible']) {
      if (!tempChange2.village.value) {
        isFormError = true;
        tempChange2.village.isError = true;
        tempChange2.village.message = 'Select Village from the dropdown.';
      } else {
        tempChange2.village.isError = false;
      }
    } else if (item === 'gram_panchayat' && tempChange2.rural_urban.value === 'Rural' && tempFormData2[item]['#required'] === true && tempFormData2[item]['#isDisabled'] === false && tempFormData2[item]['#isVisible']) {
      if (!tempChange2.gram_panchayat.value) {
        isFormError = true;
        tempChange2.gram_panchayat.isError = true;
        tempChange2.gram_panchayat.message = 'Select Gram Panchayat / ADC Village from the dropdown.';
      } else {
        tempChange2.gram_panchayat.isError = false;
      }
    }
  });

  return { nextState: tempChange2, isFormError };
};

export const validateFacilityDetailsStep = ({
  userTypeValue,
  formStateForFacility,
  formStateForField,
  facilityFormData,
  fieldFormData,
}) => {
  const isFacilityLevelUser = userTypeValue === USER_TYPE.FACILITY_LEVEL;
  const tempChange3 = isFacilityLevelUser
    ? { ...formStateForFacility }
    : { ...formStateForField };
  const facilityTabDetailsData = isFacilityLevelUser
    ? { ...facilityFormData }
    : { ...fieldFormData };

  let isFormError = false;
  Object.keys(tempChange3).forEach((item) => {
    if (item === 'hprId') {
      if (!tempChange3.hprId.value) {
        tempChange3.hprId.isError = true;
        tempChange3.hprId.message = 'HFR ID is required. Enter a valid HFR Identification.';
        isFormError = true;
      } else {
        tempChange3.hprId.isError = false;
      }
    } else if (item === 'abhaId') {
      if (!tempChange3.abhaId.value) {
        isFormError = true;
        tempChange3.abhaId.isError = true;
        tempChange3.abhaId.message = 'ABHA Number is required. Enter a valid ABHA.';
      } else {
        tempChange3.abhaId.isError = false;
      }
    } else if (item === 'hfr_id') {
      if (!tempChange3.hfr_id.value) {
        isFormError = true;
        tempChange3.hfr_id.isError = true;
        tempChange3.hfr_id.message = 'HFR ID is required. Enter a valid HFR Id';
      } else {
        tempChange3.hfr_id.isError = false;
      }
    } else if (item === 'health_facility_type') {
      if (!tempChange3.health_facility_type.value) {
        isFormError = true;
        tempChange3.health_facility_type.isError = true;
        tempChange3.health_facility_type.message = 'Health Facility Type cannot be kept blank. Select an applicable option from Dropdown.';
      } else {
        tempChange3.health_facility_type.isError = false;
      }
    } else if (item === 'health_facility_name') {
      if (!tempChange3.health_facility_name.value) {
        isFormError = true;
        tempChange3.health_facility_name.isError = true;
        tempChange3.health_facility_name.message = 'Health Facility Name cannot be kept blank. Select an applicable option from Dropdown.';
      } else {
        tempChange3.health_facility_name.isError = false;
      }
    } else if (item === 'ward' && !tempChange3.ward.value.length && facilityTabDetailsData[item]['#required'] === true && facilityTabDetailsData[item]['#isDisabled'] === false) {
      if (tempChange3.ward.value.length === 0) {
        isFormError = true;
        tempChange3.ward.isError = true;
        tempChange3.ward.message = 'Select Ward from the dropdown.';
      } else {
        tempChange3.ward.isError = false;
      }
    } else if (item === 'village' && !tempChange3.village.value.length && facilityTabDetailsData[item]['#required'] === true && facilityTabDetailsData[item]['#isVisible'] && facilityTabDetailsData[item]['#isDisabled'] === false) {
      if (tempChange3.village.value.length === 0) {
        isFormError = true;
        tempChange3.village.isError = true;
        tempChange3.village.message = 'Select Village from the dropdown.';
      } else {
        tempChange3.village.isError = false;
      }
    } else if (item === 'gram_panchayat' && !tempChange3.gram_panchayat.value.length && facilityTabDetailsData[item]['#required'] === true && facilityTabDetailsData[item]['#isVisible'] && facilityTabDetailsData[item]['#isDisabled'] === false) {
      if (tempChange3.gram_panchayat.value.length === 0) {
        isFormError = true;
        tempChange3.gram_panchayat.isError = true;
        tempChange3.gram_panchayat.message = 'Select Gram Panchayat / ADC Village from the dropdown.';
      } else {
        tempChange3.gram_panchayat.isError = false;
      }
    }
  });

  return { nextState: tempChange3, isFormError, isFacilityLevelUser };
};
